import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { NewsChatButton } from '../../../buttons/iconButtons/other/ChatCollection';
import styles from './FloatingChatButton.module.scss';
import { RefObject, useEffect, useState } from 'react';
import { UISettingsManager } from '../../../../libs/ui-settings-manager/UISettingsManager';

interface FloatingChatButtonProps {
    unreadCount: number;
    onClick: () => void;
    isOpen?: boolean;
    forceVisible?: boolean;
    buttonRef?: RefObject<HTMLDivElement>;
}

const FloatingChatButton: React.FC<FloatingChatButtonProps> = ({ 
    unreadCount, 
    onClick, 
    isOpen = false,
    forceVisible = false,
    buttonRef,
}) => {

    const { t } = useTranslation();
    const baseT = (value: string) => t('chat.' + value);
    const isUnReadNews = unreadCount > 0
    const [settings, setSettings] = useState(() => UISettingsManager.getSettings().chat);

    useEffect(() => {
        const handleSettingsChange = () => {
            const uiSettings = UISettingsManager.getSettings();
            setSettings(uiSettings.chat);
        };

        window.addEventListener('uiSettingsChanged', handleSettingsChange);
        return () => window.removeEventListener('uiSettingsChanged', handleSettingsChange);
    }, []);

    const getButtonPosition = () => {
        const isTop = settings.buttonPosition === 'top';
        const baseOffset = 114;
        const bottomOffset = 100;
        
        if (isTop) {
            return { top: baseOffset, bottom: 'auto' };
        }
        return { top: 'auto', bottom: bottomOffset };
    };

    return (
        <>
            <div
                ref={buttonRef}
                className={`${styles.buttonContainer} ${(isOpen || forceVisible) ? styles.open : ''} ${isUnReadNews ? styles.unReadNews : ''} `}
                style={getButtonPosition()}
            >
                <div onClick={onClick} className={styles.buttonWrapper}>
                    <div className={styles.buttonIndicator} />
                    <Tooltip
                        title={baseT('chatTooltip')}                       
                        placement="top"
                        getPopupContainer={() => document.body}    
                    >
                        <div>
                            <NewsChatButton sizeVariant='big' count={unreadCount} />
                        </div>
                    </Tooltip>
                </div>
            </div>
        </>
    );
};

export default FloatingChatButton;
